import { Card, Chip, Stack, Typography } from "@mui/material";
import { Attack, SuspectedHeadacheType } from "../../types";
import { FC, useState } from "react";
import { grey } from "@mui/material/colors";
import { DarkMode, ErrorOutline, LightMode } from "@mui/icons-material";
import { calcDurationDisplay, formatDateTimeRange } from "../../helpers";
import { DateTime } from "luxon";
import AttackDialog from "./AttackDialog";

interface AttackCardProps {
  attack: Attack;
  editAttack: (
    attackId: number,
    newAttack: {
      startDateTime: DateTime;
      endDateTime: DateTime;
      awake: boolean;
      disabledForTwoHours: boolean;
      suspectedHeadacheType: SuspectedHeadacheType;
      notes: string;
    },
  ) => void;
  deleteAttack: (attackId: number) => void;
}

const AttackCard: FC<AttackCardProps> = ({
  attack,
  editAttack,
  deleteAttack,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          padding: "0.5rem",
          cursor: "pointer",
          ":hover": { backgroundColor: grey[100] },
        }}
        onClick={handleOpen}
      >
        <Typography variant="body1">
          {formatDateTimeRange(attack.startDateTime, attack.endDateTime)}{" "}
          <b>
            ({calcDurationDisplay(attack.startDateTime, attack.endDateTime)})
          </b>
        </Typography>
        <Typography variant="caption">
          {attack.suspectedHeadacheType === "migraine"
            ? "Suspected migraine"
            : "Unknown headache type"}
        </Typography>
        <Stack direction="row" spacing={1} marginTop="0.5rem">
          {attack.awake ? (
            <Chip
              size="small"
              color="warning"
              icon={<LightMode />}
              label="Awake"
            />
          ) : (
            <Chip
              size="small"
              color="secondary"
              icon={<DarkMode />}
              label="Asleep"
            />
          )}
          {attack.disabledForTwoHours && (
            <Chip
              size="small"
              icon={<ErrorOutline />}
              label="Disabled for 2hrs+"
              color="error"
            />
          )}
        </Stack>
      </Card>

      <AttackDialog
        providedAttack={attack}
        editAttack={editAttack}
        deleteAttack={deleteAttack}
        handleClose={handleClose}
        open={open}
        variant="edit"
      />
    </>
  );
};

export default AttackCard;
